export default __webpack_public_path__ + "static/media/powerpoint.7a8ce92d.png";